import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import ReactQuill from 'react-quill';


const PostEdit = ({ post, currentUser, dispatchPosts, modules, quillRef, socket }) => {

    const [show, setShow] = useState(false);
    const [editRaw, setEditRaw] = useState(false);
    const handleClose = () => {
        setEditRaw(false);
        setShow(false)
    };

    const [newPost, setNewPost] = useState({ ...post });

    const handlePost = e => {
        e.preventDefault();
        let payload = { id: currentUser.user._id, jwt: currentUser.user.jwt, newPost };
        socket.emit('update post', payload);
        socket.on('post updated', data => {
            dispatchPosts({ data, type: "UPDATE_POST" });
        });
        handleClose();
    }

    const handleDelete = e => {
        e.preventDefault();
        let payload = { id: currentUser.user._id, jwt: currentUser.user.jwt, post, ip: localStorage.getItem('ip') };
        socket.emit('delete post', payload);
        socket.on('post deleted', data => {
            dispatchPosts({ data, type: 'REMOVE_POST' });
        })
        handleClose();
    }

    const handleSetPost = e => {
        setNewPost({ ...newPost, text: e });
    }

    const handleVisible = () => {
        setNewPost({ ...newPost, visible: !newPost.visible });
    }

    return (
        <>
            {(currentUser.user.isAdmin > 9 && currentUser.adminSettings) && (
                <Box sx={{ textAlign: 'center' }}>
                    <IconButton onClick={() => setShow(true)} size="small">
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Box>
            )}
            <Dialog open={show} onClose={handleClose} fullScreen>
                <DialogTitle>Edit Article</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <TextField
                            label="Title"
                            fullWidth
                            value={newPost.title}
                            onChange={e => setNewPost({ ...newPost, title: e.target.value })}
                        />
                        <TextField
                            label="Order"
                            fullWidth
                            value={newPost.order}
                            onChange={e => setNewPost({ ...newPost, order: e.target.value })}
                        />
                        <FormControlLabel
                            control={<Switch checked={newPost.visible} onChange={handleVisible} />}
                            label="Post Visible"
                        />
                        <FormControlLabel
                            control={<Switch checked={editRaw} onChange={() => setEditRaw(!editRaw)} />}
                            label="Raw HTML"
                        />
                        {editRaw ? (
                            <TextField
                                label="Raw HTML Editor"
                                multiline
                                fullWidth
                                minRows={20}
                                value={newPost.text}
                                onChange={e => setNewPost({ ...newPost, text: e.target.value })}
                            />
                        ) : (
                            <Box sx={{ bgcolor: '#585858', color: 'black' }}>
                                <ReactQuill
                                    theme="snow"
                                    ref={quillRef}
                                    value={newPost.text}
                                    modules={modules}
                                    formats={[
                                        'header', 'font', 'size', 'color',
                                        'bold', 'italic', 'underline', 'strike', 'blockquote',
                                        'list', 'bullet', 'indent',
                                        'link', 'image', 'video',
                                        'align', 'width', 'height', 'float',
                                    ]}
                                    onChange={(e) => {
                                        handleSetPost(e)
                                    }}
                                />
                            </Box>
                        )}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="error" onClick={handleDelete}>
                        Delete
                    </Button>
                    <Button variant="contained" color="warning" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="success" onClick={handlePost}>
                        Save Changes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PostEdit
